export const DEFAULT_CENTER_POSITION = {
    longitude: 48.137154,
    latitude: 11.576124
}
